import T from './translate/T'

let language = null

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
        window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=")
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
    return result
}

language = findGetParameter('lang')

T.handleUpdate(language => {
    localStorage.setItem('language', language)
})

if(!language)
language = localStorage.getItem('language')

if(!language)
language = navigator.browserLanguage || navigator.language

language = T.setLanguage(language)



// WEBPACK FOOTER //
// ./src/translate.config.js